import React from 'react';
import { Button, Modal } from 'antd';
import Layout from '../../components/layout/Layout';
import LeftSide from './partials/LeftSide';
import GridView from '../../components/elements/GridView';
import { getPaginationTotal } from '../../components/elements/GridView/GridViewBase/Pagination';

import './divisionsView.scss';

export default function () {
    const {
        divisionAssets,
        divisionAssetsPagination,
        divisionAssetsIsFetching,
        divisionDetail,
        otherAssets,
        user,
    } = this.props;

    const data = divisionAssets.map((d) => ({
        id: d.id,
        name: d.name,
        registration: d.asset_reg,
        last_online: d.last_online,
        status: parseInt(d.status, 10) === 1 ? 'Active' : 'Not Active',
        actions: (
            <Button
                className="btn btn-link btn-actions"
                onClick={() => this.removeAsset(d.id)}
                style={{
                    display: 'block',
                }}
            >
                Remove
            </Button>
        ),
    }));

    const filterOptions = (inputValue, option) => option.key.includes(inputValue);

    return (
        <Layout
            data-test="pages-divisions-view"
            className="events-view"
            title={<div>{divisionDetail.name || 'Division Details'}</div>}
            headerTitle={<div>{divisionDetail.name || 'Division Details'}</div>}
            showFooter={false}
            loading={divisionAssetsIsFetching}
        >
            <div 
                className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`} 
                style={{ overflow: 'hidden' }}
            >
                <div
                    className="content"
                    style={{ opacity: divisionAssetsIsFetching ? 0 : 1 }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div 
                                className="section__body" 
                                style={{ height: '90vh' }}
                            >
                                <div
                                    className="right-header-wrapper"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        marginBottom: '20px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '10px',
                                            position: 'absolute',
                                            top: '16px',
                                            right: '16px',
                                        }}
                                    >
                                        <Button
                                            onClick={() => this.submitUpdateDepartmentForm()}
                                            type="primary"
                                            data-testid='division-details_save-btn'
                                        >
                                            <span>Save</span>
                                        </Button>
                                        <Button
                                            onClick={() => this.handleDeleteClick(divisionDetail.id)}
                                            type="primary"
                                            data-testid='division-details_delete-btn'
                                        >
                                            <span>Delete</span>
                                        </Button>
                                    </div>
                                </div>

                                <div className="division-wrapper">
                                    <div className="left-side-wrapper">
                                        <LeftSide
                                            registerSubmitHandler={(f) => {
                                                this.submitUpdateDepartmentForm = f;
                                            }}
                                            divisionOptions={filterOptions}
                                            nonDivisionAssets={otherAssets}
                                            assignAsset={(id) => this.assignAsset(id)}
                                        />
                                    </div>
                                    <div 
                                        className="right-side-wrapper"
                                        style={{ maxWidth: '60%' }}
                                    >
                                        <GridView
                                            data={data}
                                            onChange={this.onGridChange}
                                            sortableColumns={[]}
                                            pagination={{
                                                total: parseInt(divisionAssetsPagination.totalRecords, 10) || 0,
                                                pageSize: parseInt(divisionAssetsPagination.perPageCount, 10) || 10,
                                                showSizeChanger: false,
                                                onChange: this.paginationChange,
                                                showTotal: getPaginationTotal,
                                            }}
                                            scroll={{
                                                x: 'max-content',
                                                y: 512,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <Modal
                open={this.state.showDeleteModal}
                onCancel={this.handleDeleteCancel}
                footer={this.state.deleteErrorMessage ? [
                    <Button key="cancel" onClick={this.handleDeleteCancel}>
                        Close
                    </Button>,
                ] : [
                    <Button key="cancel" onClick={this.handleDeleteCancel} disabled={this.state.isDeleting}>
                        Cancel
                    </Button>,
                    <Button
                        key="delete"
                        type="primary"
                        onClick={this.handleDeleteConfirm}
                        loading={this.state.isDeleting}
                    >
                        Delete
                    </Button>,
                ]}
            >
                {this.state.deleteErrorMessage ? (
                    <p>{this.state.deleteErrorMessage}</p>
                ) : (
                    <p>Are you sure you want to delete this division?</p>
                )}
            </Modal>

        </Layout>
    );
}
